import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getCliqloanSiteUrls } from "../utils/cliqloanSiteUrls";
import { CLIQLOAN_BRAND } from "../theme/cliqloanBrand";
import { CLIQLOAN_TYPO } from "../theme/cliqloanTypography";

export default function BlogNotFound() {
  const siteUrls = getCliqloanSiteUrls();

  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}>
      <Typography
        component="p"
        sx={{
          fontFamily: CLIQLOAN_TYPO.fontFamily,
          ...CLIQLOAN_TYPO.bodySm,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: CLIQLOAN_BRAND.textMuted,
          mb: 2,
        }}
      >
        404 — Page not found
      </Typography>
      <Typography
        component="h1"
        sx={{
          fontFamily: CLIQLOAN_TYPO.fontFamily,
          ...CLIQLOAN_TYPO.section,
          color: CLIQLOAN_BRAND.deepPurple,
          mb: 2,
        }}
      >
        This blog page doesn&apos;t exist
      </Typography>
      <Typography
        sx={{
          fontFamily: CLIQLOAN_TYPO.fontFamily,
          ...CLIQLOAN_TYPO.body,
          color: CLIQLOAN_BRAND.textMuted,
          maxWidth: "36rem",
          mx: "auto",
          mb: 4,
        }}
      >
        The article or URL may have moved. Head back to the blog listing or visit the CliQloan marketing site.
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, justifyContent: "center" }}>
        <Button
          component={Link}
          to="/blog/"
          variant="contained"
          sx={{
            bgcolor: CLIQLOAN_BRAND.cliqTeal,
            fontFamily: CLIQLOAN_TYPO.fontFamily,
            fontWeight: 700,
            ...CLIQLOAN_TYPO.buttonSm,
            textTransform: "uppercase",
            "&:hover": { bgcolor: CLIQLOAN_BRAND.cliqTealHover },
          }}
        >
          Back to blogs
        </Button>
        <Button
          component="a"
          href={siteUrls.marketingHome}
          variant="outlined"
          sx={{
            borderColor: CLIQLOAN_BRAND.deepPurple,
            color: CLIQLOAN_BRAND.deepPurple,
            fontFamily: CLIQLOAN_TYPO.fontFamily,
            fontWeight: 600,
            "&:hover": { borderColor: CLIQLOAN_BRAND.deepPurple, bgcolor: "rgba(55,57,115,0.06)" },
          }}
        >
          CliQloan home
        </Button>
      </Box>
    </Container>
  );
}
